import gql from 'graphql-tag';

export const ADD_ASSIGNMENT = gql`
  mutation addAssignment($input: AssignmentInput!) {
    addAssignment(input: $input) {
      id
      startDate
      endDate
      percentage
      numberWeek
      project {
        id
        name
      }
      resource {
        id
        name
      }
      assignmentDetail {
        assignmentId
        week
        year
        daysAvailable
        daysWorked
        validated
      }
    }
  }
`;

export const UPDATE_ASSIGNMENT = gql`
  mutation updateAssignment($id: ID!, $input: AssignmentInput!) {
    updateAssignment(id: $id, input: $input) {
      id
      startDate
      endDate
      percentage
      numberWeek
      project {
        id
        name
      }
      resource {
        id
        name
      }
      assignmentDetail {
        assignmentId
        week
        year
        daysAvailable
        daysWorked
        validated
      }
    }
  }
`;

export const DELETE_ASSIGNMENT = gql`
  mutation deleteAssignment($id: ID!) {
    deleteAssignment(id: $id) {
      id
      project {
        id
        name
      }
      resource {
        id
        name
      }
    }
  }
`;

export const ADD_PROJECT = gql`
  mutation addProject($input: ProjectInput!) {
    addProject(input: $input) {
      id
      name
      budget
      activity
      boondmanagerId
      startDate
      endDate
      type
      managers {
        id
        name
        boondmanagerId
      }
      consumed
      assignments {
        id
        startDate
        endDate
        percentage
        project {
          id
          name
        }
        resource {
          id
          name
        }
        assignmentDetail {
          assignmentId
          week
          year
          daysAvailable
          daysWorked
        }
      }
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation updateProject($id: ID!, $input: ProjectInput!) {
    updateProject(id: $id, input: $input) {
      id
      name
      budget
      activity
      boondmanagerId
      startDate
      endDate
      type
      managerId
      consumed
      assignments {
        id
        startDate
        endDate
        percentage
        project {
          id
          name
        }
        resource {
          id
          name
        }
        assignmentDetail {
          assignmentId
          week
          year
          daysAvailable
          daysWorked
        }
      }
    }
  }
`;

export const LOGIN = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      userId
      token
      tokenExpiration
    }
  }
`;

export const ADD_USER = gql`
  mutation createUser($email: String!, $password: String!, $role: String!) {
    createUser(email: $email, password: $password, role: $role) {
      id
      email
      password
      role
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: ID!
    $email: String!
    $password: String
    $role: String!
  ) {
    updateUser(id: $id, email: $email, password: $password, role: $role) {
      id
      email
      role
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;

export const UPDATE_BOOND_DATA = gql`
  mutation updateBoondData {
    updateBoondData
  }
`;
